import { TOKEN_STORAGE_KEY } from "./constants";

function getDefaultApiBaseUrl(): string {
  if (typeof window !== "undefined") {
    // Relative path for Nginx proxy
    return "/api/v1";
  }

  return "http://localhost:8305/api/v1";
}

export const API_BASE_URL =
  typeof window !== "undefined" ? "/api/v1" : (process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8305/api/v1");

export function getStoredToken(): string {
  if (typeof window === "undefined") return "";
  return localStorage.getItem(TOKEN_STORAGE_KEY) ?? "";
}

export function setSession(token: string): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
}

export function clearSession(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem("activeTenantId");
}
